import React, { useState, useEffect, useRef } from "react";
import "../../../styles/utils/modal/CustomFinalModal.scss";
import {
  customCreateTitle,
  customCreateCoverPrompt,
  customCreateCoverImage,
  customSaveBook,
} from "../../../api/customAPI";
import { getStoryImageStatus } from "../../../api/StoryAPI";
import Loading from "../loading/Loading";
import CompleteModal from "../../creating/modal/CompleteModal";
import ErrorModal from "./ErrorModal";
import { WordFilter } from "../../../utils/wordFilter/WordFilter";

const CustomModal = ({
  story,
  contentList,
  onClose,
  user_id,
  character_job_id,
  storyPrompt,
  storyId,
}) => {
  const [errorInfo, setErrorInfo] = useState(null);
  const [bookTitle, setbookTitle] = useState("");
  const [backgroundImage, setBackgroundImage] = useState("");
  const [showLoading, setShowLoading] = useState(false);
  const [generateEnd, setGenerateEnd] = useState(false);
  const [loadingTitle, setLoadingTitle] = useState("");
  const [loadingFlag, setLoadingFlag] = useState("");
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [isContentVisible, setIsContentVisible] = useState(true);
  const [showCoverButton, setshowCoverButton] = useState(false);
  const [showCompleteModal, setShowCompleteModal] = useState(false);
  const [titleMade, setTitleMade] = useState(false);
  const [coverMade, setCoverMade] = useState(false);
  const [studentName, setStudentName] = useState("");
  const [showNameModal, setShowNameModal] = useState(false);
  const [savedBookId, setSavedBookId] = useState(null);

  const [showTitleEditModal, setShowTitleEditModal] = useState(false);
  const [tempTitle, setTempTitle] = useState("");

  const audioRef = useRef(null);
  const isMountedRef = useRef(true);

  const controlLoading = (on) => {
    if (on) {
      setGenerateEnd(false);
      setShowLoading(true);
    } else {
      setGenerateEnd(true);
      setShowLoading(false);
    }
  };

  const handleGoBack = () => {
    onClose();
  };

  // 제목 수정 모달 열기
  const handleOpenTitleEditModal = () => {
    setTempTitle(bookTitle);
    setShowTitleEditModal(true);
  };

  // 제목 수정 저장
  const handleSaveEditedTitle = () => {
    if (!tempTitle.trim()) {
      alert("제목을 입력해주세요!");
      return;
    }

    if (WordFilter(tempTitle)) {
      alert(
        "안전하지 않은 단어 또는 부적절한 표현이 포함되어 있습니다.\n다른 표현으로 수정해주세요.",
      );
      return;
    }
    setbookTitle(tempTitle.trim());
    setShowTitleEditModal(false);
  };

  useEffect(() => {
    if (bookTitle.length != 0 && backgroundImage.length != 0) {
      setIsContentVisible(false);
      setIsButtonEnabled(true);
    }
  }, [bookTitle, backgroundImage]);

  const handleMakeTitle = async () => {
    setLoadingTitle("특별한 동화 제목을 만드는 중이예요!");
    setLoadingFlag("title");
    controlLoading(true);

    const isAudioInDOM = () =>
      audioRef.current && document.body.contains(audioRef.current);

    if (isMountedRef.current && isAudioInDOM()) {
      audioRef.current.volume = 0.15;
      audioRef.current.play().catch((error) => {
        console.error("오디오 재생에 실패했습니다.", error);
      });
    }

    try {
      let stories = "";
      for (const content of contentList) {
        stories = stories + " " + (content.page_content || content.contents);
      }

      const data = {
        user_id: user_id,
        story_id: storyId,
        items: storyPrompt,
      };

      const res = await customCreateTitle(data);
      console.log("[@myself title res]", res);

      const code =
        res?.errCode ||
        res?.errorCode ||
        res?.error?.errCode ||
        res?.error?.errorCode ||
        null;

      const msg =
        res?.errMsg ||
        res?.errorMessage ||
        res?.error?.errMsg ||
        res?.error?.errorMessage ||
        res?.error ||
        "제목을 만드는 중 오류가 발생했어요. 잠시 후 다시 시도해 주세요.";

      if (!res?.success) {
        if (code === "Magicbean_ERR_00") {
          controlLoading(false);
          setErrorInfo({
            code,
            message:
              "체험에 필요한 마법콩이 부족합니다.\\n마법콩을 충전해주세요.",
          });
          return;
        }

        alert(msg);
        setShowLoading(false);
        setshowCoverButton(false);
        return;
      }

      let title = res.data;
      if (typeof title === "string" && title.includes('"')) {
        title = title.replaceAll('"', "");
      }

      setTimeout(() => {
        setbookTitle(title);
        controlLoading(false);
        setshowCoverButton(true);
        setTitleMade(true);
      }, 3000);
    } catch (e) {
      console.error("[handleMakeTitle error]", e);
      controlLoading(false);
      alert("제목을 만드는 중 오류가 발생했어요. 잠시 후 다시 시도해 주세요.");
    }
  };

  const handleSetBackgroundImage = async () => {
    setLoadingTitle("동화의 세계가 드디어 완성되어요!");
    setLoadingFlag("title");
    controlLoading(true);
    await generateBookcover();
  };

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  const generateBookcover = async () => {
    try {
      let stories = "";
      for (const content of contentList || []) {
        if (content?.page_content || content?.contents) {
          stories += ` ${content.page_content || content.contents}`;
        }
      }

      // 1. 프롬프트 생성
      const promptData = {
        user_id: user_id,
        story_id: storyId,
        title: bookTitle,
        items: storyPrompt,
      };
      const res_prompt = await customCreateCoverPrompt(promptData);

      if (!res_prompt?.success) {
        const code =
          res_prompt?.errCode ||
          res_prompt?.errorCode ||
          res_prompt?.error?.errCode ||
          res_prompt?.error?.errorCode ||
          null;

        const msg =
          res_prompt?.errMsg ||
          res_prompt?.errorMessage ||
          res_prompt?.error?.errMsg ||
          res_prompt?.error?.errorMessage ||
          res_prompt?.error ||
          "표지 프롬프트 생성에 실패했어요. 다시 시도해주세요.";

        if (code === "Magicbean_ERR_00") {
          setShowLoading(false);
          setErrorInfo({
            code,
            message:
              "체험에 필요한 마법콩이 부족합니다.\\n마법콩을 충전해주세요.",
          });
          return;
        }

        alert(msg);
        setShowLoading(false);
        return;
      }

      // 2. 이미지 생성
      const imageData = {
        user_id: user_id,
        character_job_id: character_job_id,
        background_prompt: res_prompt.data.background_prompt,
        character_prompt: res_prompt.data.character_prompt,
      };
      const res_image = await customCreateCoverImage(imageData);

      if (!res_image?.success) {
        const code =
          res_image?.errCode ||
          res_image?.errorCode ||
          res_image?.error?.errCode ||
          res_image?.error?.errorCode ||
          null;

        const msg =
          res_image?.errMsg ||
          res_image?.errorMessage ||
          res_image?.error?.errMsg ||
          res_image?.error?.errorMessage ||
          res_image?.error ||
          "표지 이미지를 생성하는 중 오류가 발생했어요. 잠시 후 다시 시도해 주세요.";

        if (code === "Magicbean_ERR_00") {
          setShowLoading(false);
          setErrorInfo({
            code,
            message:
              "체험에 필요한 마법콩이 부족합니다.\\n마법콩을 충전해주세요.",
          });
          return;
        }

        alert(msg);
        setShowLoading(false);
        return;
      }

      const { batch_id } = res_image.data || {};
      if (!batch_id) {
        alert("표지 생성 batch_id가 없습니다.");
        setShowLoading(false);
        return;
      }

      const timeoutMs = 120000;
      const startedAt = Date.now();
      let coverUrl = "";

      while (true) {
        const statusRes = await getStoryImageStatus({
          batch_id,
          user_id: user_id,
        });

        console.log(
          "[MYSELF COVER] status:",
          statusRes?.data?.status,
          "done?",
          statusRes?.data?.all_completed,
          "imgs:",
          statusRes?.data?.images?.length,
        );

        if (!statusRes?.success) {
          throw new Error("표지 상태 조회 실패");
        }

        const d = statusRes.data || {};
        if (d.status === "failed") {
          throw new Error("표지 생성 실패");
        }

        if (d.all_completed === true && Array.isArray(d.images)) {
          coverUrl = d.images?.[0]?.url || "";
          console.log("✅ MYSELF COVER 완료! URL:", coverUrl);
          break;
        }

        if (Date.now() - startedAt > timeoutMs) {
          throw new Error("표지 생성 대기 시간 초과");
        }

        await sleep(2000);
      }

      if (!coverUrl) {
        throw new Error("표지 URL이 비어 있습니다.");
      }

      setBackgroundImage(coverUrl);
      controlLoading(false);

      if (audioRef.current) {
        try {
          await audioRef.current.play();
        } catch (e) {
          console.warn("오디오 재생 실패:", e);
        }
      }

      setCoverMade(true);
    } catch (e) {
      console.error("표지 생성 에러:", e);
      setShowLoading(false);
      alert("표지 생성 중 오류가 발생했어요. 잠시 후 다시 시도해주세요.");
    }
  };

  const handleCompletedBtn = async () => {
    setShowNameModal(true);
  };

  const handleSaveFinalBook = async () => {
    if (!studentName.trim()) {
      alert("이름을 입력해주세요!");
      return;
    }

    setIsButtonEnabled(false);
    setShowNameModal(false);

    const fullTitle = `${bookTitle} - ${studentName.trim()}`;
    const body = {
      user_id: user_id,
      character_job_id: character_job_id,
      title: fullTitle,
      cover_url: backgroundImage,
      items: story,
    };

    const res = await customSaveBook(body);

    const row = Array.isArray(res)
      ? res[0]
      : Array.isArray(res?.data)
        ? res.data[0]
        : (res?.data ?? res);

    const newBookId = row?.book_id ?? row?.id;

    if (!newBookId) {
      console.log("unexpected save response shape:", res);
      alert("서버 응답에서 새 책 ID를 찾지 못했어요.");
      setIsButtonEnabled(true);
      return;
    }

    setSavedBookId(newBookId);
    setShowCompleteModal(true);
  };

  return (
    <section
      className="final-modal-section"
      style={
        backgroundImage.length === 0
          ? { backgroundImage: backgroundImage }
          : { backgroundImage: `url(${backgroundImage})` }
      }
    >
      <audio ref={audioRef} src="/audio/twinkle-storybook-final.mp3" />
      {(isContentVisible || !isButtonEnabled) && (
        <>
          <div className="loader"></div>
          {!isButtonEnabled && backgroundImage && bookTitle && (
            <p className="sub-title">
              동화를 저장 중 입니다. 조금만 기다려주세요!
            </p>
          )}
        </>
      )}
      {bookTitle && !backgroundImage && (
        <p className="title-completed-notice">제목이 완성되었습니다</p>
      )}
      <h2 className={`final-title ${bookTitle ? "sucess" : ""}`}>
        {bookTitle
          ? studentName
            ? `${bookTitle} - ${studentName}`
            : bookTitle
          : "제목을 만들어주세요"}
      </h2>

      {bookTitle && !backgroundImage && (
        <p className="cover-instruction-notice blink">표지를 만들어주세요</p>
      )}
      <div
        className={`container-flex ${titleMade && coverMade ? "reverse" : ""}`}
      >
        <div className="choose-btn-container">
          <button
            className="make-buttons make-title-button"
            onClick={() => {
              handleMakeTitle();
            }}
          >
            {bookTitle ? "제목 다시 만들기" : "제목 만들기"}
          </button>
          {bookTitle && (
            <button
              className="make-buttons edit-title-button"
              onClick={handleOpenTitleEditModal}
            >
              제목 직접 수정하기
            </button>
          )}
          {showCoverButton && (
            <button
              className="make-buttons make-cover-button"
              onClick={() => {
                handleSetBackgroundImage();
              }}
            >
              {backgroundImage ? "표지 다시 만들기" : "표지 만들기"}
            </button>
          )}
        </div>
        <button
          className={`complete ${isButtonEnabled ? "on" : ""}`}
          disabled={!isButtonEnabled}
          onClick={handleCompletedBtn}
        >
          만든 그림동화 저장하기
        </button>
      </div>
      <div className="go-back" onClick={handleGoBack}>
        뒤로가기
      </div>

      {showLoading && (
        <Loading
          title={loadingTitle}
          end={generateEnd}
          flag={loadingFlag}
          onEnd={() => setShowLoading(false)}
        />
      )}
      {showTitleEditModal && (
        <div className="name-modal-overlay">
          <div className="name-modal">
            <h3>어떤 제목으로 바꿀까요?</h3>
            <input
              type="text"
              placeholder="제목을 입력하세요"
              value={tempTitle}
              onChange={(e) => setTempTitle(e.target.value)}
            />
            <div className="name-modal-buttons">
              <button
                className="cancel"
                onClick={() => setShowTitleEditModal(false)}
              >
                취소
              </button>
              <button className="save" onClick={handleSaveEditedTitle}>
                저장
              </button>
            </div>
          </div>
        </div>
      )}

      {showCompleteModal && (
        <CompleteModal
          contents_json={contentList}
          title={bookTitle}
          backgroundImage={backgroundImage}
          bookId={savedBookId}
        />
      )}
      {showNameModal && (
        <div className="name-modal-overlay">
          <div className="name-modal">
            <h3>동화를 만든 친구의 이름을 적어주세요</h3>
            <input
              type="text"
              placeholder="예: 홍길동"
              value={studentName}
              onChange={(e) => setStudentName(e.target.value)}
            />
            <div className="name-modal-buttons">
              <button onClick={() => setShowNameModal(false)}>취소</button>
              <button onClick={handleSaveFinalBook}>저장</button>
            </div>
          </div>
        </div>
      )}
      {errorInfo && (
        <ErrorModal
          error_message={errorInfo.message}
          onClose={() => setErrorInfo(null)}
        />
      )}
    </section>
  );
};

export default CustomModal;
